import FormWithProvider from 'components/forms/form/Form';
import {
  PresetDateRange,
  getRangeFromPresetDateRange,
  getTimeSpanFromPresetDateRange,
} from 'utils/dateTimeUtils';
import { DateType } from 'pages/analyticsAndHostQuality/analytics/types/Analytics.types';
import HostQualityFilterLoader from '../HostQualityFilterLoader';
import useHostQualityFilter from '../useHostQualityFilter';
import HostQualityFilters from './HostQualityFilters';
import HostQualityFilterFormWatcher from './HostQualityFilterFormWatcher';

const HostQualityFiltersWrapper = ({
  forcePresetDateRange,
  forceDateType,
}: {
  forcePresetDateRange?: PresetDateRange;
  forceDateType?: DateType;
}) => {
  const defaultDateRange = forcePresetDateRange || PresetDateRange.THIS_YEAR;
  const defaultDateType = forceDateType || DateType.OCCUPANCY;
  const { isLoading } = useHostQualityFilter();

  if (isLoading) {
    return <HostQualityFilterLoader />;
  }

  return (
    <FormWithProvider
      data-testid="host-quality-filter-form"
      horizontal
      defaultValues={{
        presetDateRange: defaultDateRange,
        dateType: defaultDateType,
        propertyUid: '',
        channel: '',
        ownerUid: '',
        location: '',
        range: {
          startDate: getRangeFromPresetDateRange?.(defaultDateRange)?.[0],
          endDate: getRangeFromPresetDateRange?.(defaultDateRange)?.[1],
        },
        timeSpan: getTimeSpanFromPresetDateRange(defaultDateRange),
      }}
      schema={{}}
      onSubmit={() => {}}
    >
      <HostQualityFilters />
      <HostQualityFilterFormWatcher />
    </FormWithProvider>
  );
};

HostQualityFiltersWrapper.defaultProps = {
  forcePresetDateRange: null,
  forceDateType: null,
};

export default HostQualityFiltersWrapper;
